<style>
.swal2-popup .swal2-icon {
  margin-left: 39% !important;
}
</style>
<style lang="scss" scoped>
.card-custom {
  .body {
    .fixed {
      position: fixed;
      width: 77.1rem;
      background-color: #ffffff;
      left: 23.6rem;
      z-index: 1;
      top: 15%;
      .search {
        margin-left: 2% !important;
      }
    }
    .move-below {
      margin-top: 13% !important;
    }
  }
}
</style>
<template>
  <div class="card card-custom">
    <div class="card-body">
      <div class="fixed">
        <adv-search
          @search="advSearch"
          :is_date_range="true"
          :is_service="true"
          :is_status="true"
          :is_job_report="false"
          :is_location="true"
          :is_service_report="true"
          :is_payment_status="true"
          :reportData="this.excelreports"
          :titleworksheet="this.titleworksheet"
          :json_fields="this.json_fields"
          :header="this.header"
          :report_name="'florida_service_report.xls'"
        />
      </div>
      <div
        class="row"
        style="margin-top: 4%"
        v-if="reports.length > 0 && !getLoadingData"
      >
        <div class="col-md-12">
          <v-table :columns="columns">
            <tr v-for="(item, index) in reports" :key="index">
              <td >
                {{ ++index}}
              </td>
              <td v-if="search.location == 'all'">
                {{ item.location_name }}
              </td>

              <td>{{ item.applicant }}</td>
              <td>{{ item.ori_number }}</td>

              <td v-if="item.schedule_date != null && item.schedule_date != ''">
                {{ dateFormat(item.schedule_date) }}
              </td>
              <td class="text-center" v-else>-</td>
              <td>{{ item.payment_status }}</td>
              <td>{{ item.service_status }}</td>
              <td class="text-right">$ {{ item.cost | toFixedTwoDigit }}</td>
              <td class="text-right">$ {{ item.markup | toFixedTwoDigit }}</td>
              <td class="text-right">$ {{ item.tax | toFixedTwoDigit }}</td>
              <td class="text-right">
                $ {{ item.commission | toFixedTwoDigit }}
              </td>
              <td class="text-right">$ {{ item.amount | toFixedTwoDigit }}</td>
            </tr>
            <tr>
              <td :colspan="search.location == 'all' ? 7 : 6">
                <b>Grand Total</b>
              </td>
              <td class="text-right">
                <b>
                  $
                  {{ total_cost | toFixedTwoDigit }}</b
                >
              </td>
              <td class="text-right">
                <b>
                  $
                  {{ total_markup | toFixedTwoDigit }}</b
                >
              </td>
              <td class="text-right">
                <b>
                  $
                  {{ total_tax | toFixedTwoDigit }}</b
                >
              </td>
              <td class="text-right">
                <b>
                  $
                  {{ total_commission | toFixedTwoDigit }}</b
                >
              </td>
              <td class="text-right">
                <b>
                  $
                  {{ total_rate | toFixedTwoDigit }}</b
                >
              </td>
            </tr>
          </v-table>
        </div>
      </div>
      <div class="row" v-if="reports.length < 1 && !getLoadingData && !load">
        <div class="col-md-12 text-center">
          <h4>no report(s) found</h4>
        </div>
      </div>
      <div class="row" v-if="load" style="opacity: 0.8">
        <div class="col-md-12 text-center">
          <h4>Please select the criteria</h4>
        </div>
      </div>

      <div class="row move-below" v-if="getLoadingData">
        <div class="col-md-12 text-center">
          <v-data-loader></v-data-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
import {
  FETCH_CLIENTS,
  FETCH_SERVICES,
  FETCH_SP_ORI_WISE_REPORT
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import vTable from "@/includes/table/Datatable";
import { mapGetters } from "vuex";
import vDataLoader from "@/components/frontend/spinner.vue";
import AdvSearch from "@/includes/search/AdvSearch";
// import * as PDF417 from "pdf417-generator";
export default {
  components: {
    vTable,
    vDataLoader,
    AdvSearch
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getSearchDate"]),

    total_commission: function() {
      let total = 0;
      if (this.reports.length != 0) {
        this.reports.forEach(element => {
          total += parseFloat(element.commission);
        });
      }
      return total;
    },
    total_cost: function() {
      let total = 0;
      if (this.reports.length != 0) {
        this.reports.forEach(element => {
          total += parseFloat(element.cost);
        });
      }
      return total;
    },
    total_markup: function() {
      let total = 0;
      if (this.reports.length != 0) {
        this.reports.forEach(element => {
          total += parseFloat(element.markup);
        });
      }
      return total;
    },
    total_tax: function() {
      let total = 0;
      if (this.reports.length != 0) {
        this.reports.forEach(element => {
          total += parseFloat(element.tax);
        });
      }
      return total;
    },
    total_rate: function() {
      let total = 0;
      if (this.reports.length != 0) {
        this.reports.forEach(element => {
          total += parseFloat(element.amount);
        });
      }
      return total;
    }
  },
  filters: {
    toFixedTwoDigit(amount) {
      return parseFloat(amount).toFixed(2);
    }
  },
  data() {
    return {
      search: {
        service: "all",

        date_from: "",
        date_to: "",
        location: "all",
        service_status: "all",
        payment_status: "all",
        search_text: ""
      },
      titleworksheet: "",

      getLoadingData: false,
      columns: [
      {
          name: "S.No",
          width: "",
          label: "S.No",
          class: ""
        },
        {
          name: "location",
          width: "",
          label: "Location",
          class: ""
        },

        {
          name: "Applicant Name",
          width: "",
          label: "Applicant Name",
          class: ""
        },

        {
          name: "ORI",
          width: "",
          label: "ORI ",
          class: ""
        },

        {
          name: "Scheduled Date",
          width: "",
          label: "Scheduled Date",
          class: ""
        },
        {
          name: "Payment Status",
          width: "",
          label: "Payment Status",
          class: ""
        },
        {
          name: "Service Status",
          width: "",
          label: "Service Status",
          class: ""
        },

        {
          name: "cost",
          width: "8%",
          label: "Cost",
          class: "text-right"
        },
        {
          name: "markup",
          width: "8%",
          label: "Markup",
          class: "text-right"
        },

        {
          name: "tax",
          width: "8%",
          label: "Tax",
          class: "text-right"
        },
        {
          name: "commission",
          width: "8%",
          label: "Commission",
          class: "text-right"
        },
        {
          name: "amount",
          width: "8%",
          label: "Amount",
          class: ""
        }
      ],
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard"
        },
        {
          id: 2,
          title: "Report",
          route: ""
        },
        {
          id: 2,
          title: "Location Job Report",
          route: ""
        }
      ],
      reports: [],
      header: [],
      load: true,
      excelreports: [],
      json_fields: {
        "Location	": "location_name",
        "Applicant Name": "applicant",
        ORI: "cri",
        "Schedule Date": "schedule_date",
        "Payment Status": "payment_status",
        "Service Status": "service_status",
        Cost: "cost",
        Markup: "markup",
        Tax: "tax",
        Commission: "commission",
        Amount: "amount"
      }
    };
  },

  mounted() {
    this.$store.dispatch(FETCH_CLIENTS);
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_SERVICES, this.search.location);
  },

  methods: {
    advSearch(value) {
      this.getLoadingData = true;
      this.load = false;
      let { header, search, footer } = value;
      this.header = header;
      this.search = { ...search };
      this.titleworksheet = search.date_from + " - " + search.date_to;
      this.tablereset();

      this.$store
        .dispatch(FETCH_SP_ORI_WISE_REPORT, search)
        .then(res => {
          this.getLoadingData = false;
          this.reports = res.data;
          this.excelreports = [...res.data];
          let data = [...res.data];
          let rate = 0;
          if (data.length != 0) {
            data.forEach(element => {
              rate += parseFloat(element.amount);
            });
          }
          let cost = 0;
          if (data.length != 0) {
            data.forEach(element => {
              cost += parseFloat(element.cost);
            });
          }
          let markup = 0;
          if (data.length != 0) {
            data.forEach(element => {
              markup += parseFloat(element.markup);
            });
          }
          let tax = 0;
          if (data.length != 0) {
            data.forEach(element => {
              tax += parseFloat(element.tax);
            });
          }
          let commission = 0;
          if (data.length != 0) {
            data.forEach(element => {
              commission += parseFloat(element.commission);
            });
            let gtotal = {
              schedule_date: "",
              applicant: "",
              location_name: "",
              payment_status: "",
              service_status: "Grand Total",
              cost: cost,
              markup: markup,
              tax: tax,
              commission: commission,
              amount: rate
            };
            this.excelreports.push(gtotal);
          }
          let foo = {
            schedule_date: "",
            applicant: "",
            location_name: "",
            payment_status: "",
            service_status: "",
            cost: footer[4],
            markup: footer[3],
            tax: footer[2],
            commission: footer[1],
            amount: footer[0]
          };
          this.excelreports.push(foo);
        })
        .catch(err => {
          this.getLoadingData = false;
          this.msg = err.error;
        });
    },
    tablereset() {
      if (this.search.location != "all") {
        this.columns = [
        {
          name: "S.No",
          width: "",
          label: "S.No",
          class: ""
        },
          {
            name: "Applicant Name",
            width: "",
            label: "Applicant Name",
            class: ""
          },
          {
            name: "ORI",
            width: "",
            label: "ORI ",
            class: ""
          },
          {
            name: "Schedule Date",
            width: "",
            label: "Schedule Date",
            class: ""
          },
          {
            name: "Payment Status",
            width: "",
            label: "Payment Status",
            class: ""
          },
          {
            name: "Service Status",
            width: "",
            label: "Service Status",
            class: ""
          },

          {
            name: "cost",
            width: "8%",
            label: "Cost",
            class: "text-right"
          },
          {
            name: "markup",
            width: "8%",
            label: "Markup",
            class: "text-right"
          },

          {
            name: "tax",
            width: "8%",
            label: "Tax",
            class: "text-right"
          },
          {
            name: "commission",
            width: "8%",
            label: "Commission",
            class: "text-right"
          },
          {
            name: "amount",
            width: "8%",
            label: "Amount",
            class: ""
          }
        ];
        this.json_fields = {
          "Applicant Name": "applicant",
          ORI: "ori_number",
          "Schedule Date": "schedule_date",
          "Payment Status": "payment_status",
          "Service Status": "service_status",
          Cost: "cost",
          Markup: "markup",
          Tax: "tax",
          Commission: "commission",
          Amount: "amount"
        };
      } else {
        this.json_fields = {
          "Location	": "location_name",
          "Applicant Name": "applicant",
          ORI: "ori_number",
          "Schedule Date": "schedule_date",
          "Payment Status": "payment_status",
          "Service Status": "service_status",
          Cost: "cost",
          Markup: "markup",
          Tax: "tax",
          Commission: "commission",
          Amount: "amount"
        };
        this.columns = [
        {
          name: "S.No",
          width: "",
          label: "S.No",
          class: ""
        },
          {
            name: "location",
            width: "",
            label: "Location",
            class: ""
          },

          {
            name: "Applicant Name",
            width: "",
            label: "Applicant Name",
            class: ""
          },
          {
            name: "ORI",
            width: "",
            label: "ORI ",
            class: ""
          },

          {
            name: "Schedule Date",
            width: "",
            label: "Schedule Date",
            class: ""
          },
          {
            name: "Payment Status",
            width: "",
            label: "Payment Status",
            class: ""
          },
          {
            name: "Service Status",
            width: "",
            label: "Service Status",
            class: ""
          },
          {
            name: "cost",
            width: "8%",
            label: "Cost",
            class: "text-right"
          },
          {
            name: "markup",
            width: "8%",
            label: "Markup",
            class: "text-right"
          },

          {
            name: "tax",
            width: "8%",
            label: "Tax",
            class: "text-right"
          },
          {
            name: "commission",
            width: "8%",
            label: "Commission",
            class: "text-right"
          },
          {
            name: "amount",
            width: "8%",
            label: "Amount",
            class: "text-right"
          }
        ];
      }
    },
    refreshData() {
      this.pagination = {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15
      };
    },

    statusColor(status) {
      if (status == "P") {
        return "warning";
      }
      if (status == "C") {
        return "success";
      }
      if (status == "U") {
        return "info";
      }
      if (status == "Cancel") {
        return "danger";
      }
    },
    selectedPage(n) {
      this.pagination.current_page = n;
      //   this.appData();
    },
    nextPage() {
      this.pagination.current_page = this.pagination.current_page + 1;
      //   this.appData();
    },
    lastPage() {
      this.pagination.current_page = this.pagination.total_page;
      //   this.appData();
    },
    firstPage() {
      this.pagination.current_page = 1;
      //   this.appData();
    },
    previousPage() {
      this.pagination.current_page = this.pagination.current_page - 1;
      //   this.appData();
    }
  }
};
</script>
